import { render, staticRenderFns } from "./DataGroups.vue?vue&type=template&id=60ce272c&scoped=true"
import script from "./DataGroups.vue?vue&type=script&lang=js"
export * from "./DataGroups.vue?vue&type=script&lang=js"
import style0 from "./DataGroups.vue?vue&type=style&index=0&id=60ce272c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce272c",
  null
  
)

export default component.exports